import * as React from 'react';
import { Autocomplete } from '@mui/material';
import { MainInput } from './Styles';

export const brandOptionLabel = (vendor) => vendor?.brandName || vendor?.name || '';

export const brandFilterOptions = (options, { inputValue }) => {
    const query = inputValue.trim().toLowerCase();
    if (!query) return options;
    return options.filter((option) => {
        const brand = (option.brandName || '').toLowerCase();
        const name = (option.name || '').toLowerCase();
        return brand.includes(query) || name.includes(query);
    });
};

const ALL_ID = '__all__';

const vendorList = (vendors) => {
    const list = Array.isArray(vendors) ? vendors : (vendors?.docs || []);
    return list.filter((vendor) => vendor?._id);
};

const labelOf = brandOptionLabel;

export const BrandSelect = ({
    vendors,
    value,
    onChange,
    label = 'Brand',
    emptyLabel,
    emptyValue = null,
    sx,
    autoFocus,
    margin = 'normal',
    fullWidth = true,
    multiple = false,
}) => {
    const options = vendorList(vendors);
    const choices = !multiple && emptyLabel
        ? [{ _id: ALL_ID, brandName: emptyLabel }, ...options]
        : options;
    const currentId = value === '' || value == null
        ? (emptyLabel ? ALL_ID : null)
        : value;
    const selected = multiple
        ? choices.filter((vendor) => (Array.isArray(value) ? value : []).map(String).includes(String(vendor._id)))
        : choices.find((vendor) => String(vendor._id) === String(currentId)) || null;
    const [open, setOpen] = React.useState(false);
    const [inputValue, setInputValue] = React.useState('');

    React.useEffect(() => {
        if (multiple || open) return;
        setInputValue(selected ? labelOf(selected) : '');
    }, [selected, open, multiple]);

    return (
        <Autocomplete
            sx={{ width: '100%', flex: '1 1 240px', minWidth: 240, ...sx }}
            fullWidth={fullWidth}
            multiple={multiple}
            options={choices}
            value={selected}
            autoHighlight
            openOnFocus
            open={open}
            onOpen={() => {
                setOpen(true);
                setInputValue('');
            }}
            onClose={() => {
                setOpen(false);
                if (!multiple) setInputValue(selected ? labelOf(selected) : '');
            }}
            inputValue={inputValue}
            onInputChange={(_, next, reason) => {
                if (reason === 'reset') return;
                setInputValue(next);
            }}
            onChange={(_, next) => {
                if (multiple) {
                    onChange((next || []).map((option) => option._id));
                    setInputValue('');
                    return;
                }
                if (!next || next._id === ALL_ID) onChange(emptyValue);
                else onChange(next._id);
            }}
            getOptionLabel={labelOf}
            isOptionEqualToValue={(option, current) => String(option._id) === String(current._id)}
            filterOptions={brandFilterOptions}
            renderInput={(params) => (
                <MainInput
                    {...params}
                    margin={margin}
                    fullWidth
                    label={label}
                    autoFocus={autoFocus}
                    sx={{ width: '100%' }}
                />
            )}
        />
    );
};
